import React from 'react';
import './Footer.css';

export default function Footer({ user, onLogout }) {
  if (!user) return null;

  const shortEmail = user.email ? user.email.split('@')[0] : '';

  return (
    <footer className="App-footer">
      <div className="footer-inner app-shell-width">
        <span className="footer-email">Signed in as <strong>{shortEmail}</strong></span>
        <button className="logout-btn" onClick={onLogout}>Logout</button>
      </div>
    </footer>
  );
}
